module.exports = __webpack_public_path__ + "img/Dantam Fashion 06.aee00254.jpg";